// extracted by mini-css-extract-plugin
module.exports = {"nearestbranchBox":"_2QhS1"};